import React from "react";
import { MotifIcon, MotifTooltip, MotifTruncate } from "@ey-xd/motif-react";
import { IconoirHelpCircle } from "@ey-xd/motif-icon";
import "./OrderItemsHeaderTooltip.scss";
import {
  skuIDInfo,
  unitCostInfo,
  unitPerPeriodInfo,
  numberOfPeriodsInfo,
  subTotalInfo,
  totalCostInfo,
} from "../../../utils/skuTable";

type TooltipType =
  | "sku"
  | "unitCost"
  | "unitsPerPeriod"
  | "numberOfPeriods"
  | "totalCost"
  | "subtotal";

interface OrderItemsHeaderTooltipProps {
  label: string;
  type: TooltipType;
  maxWidth?: number;
}

const getTooltipContent = (type: TooltipType) => {
  switch (type) {
    case "sku":
      return skuIDInfo();
    case "unitCost":
      return unitCostInfo();
    case "unitsPerPeriod":
      return unitPerPeriodInfo();
    case "numberOfPeriods":
      return numberOfPeriodsInfo();
    case "subtotal":
      return subTotalInfo();
    case "totalCost":
      return totalCostInfo();
    default:
      return null;
  }
};

const OrderItemsHeaderTooltip: React.FC<OrderItemsHeaderTooltipProps> = ({
  label,
  type,
  maxWidth,
}) => {
  return (
    <span className="order-items-header-with-tooltip">
      <span className="order-items-header-label">
        {maxWidth ? (
          <MotifTruncate maxLines={1} maxWidth={Math.round(maxWidth)}>
            {label}
          </MotifTruncate>
        ) : (
          <>{label}</>
        )}
      </span>
      <MotifTooltip
        contentClassName="tooltip-content"
        hideArrow={true}
        allowClick={false}
        placement="top"
        trigger={
          <span className="order-items-tooltip-trigger">
            <MotifIcon
              iconFunction={IconoirHelpCircle}
              size="16"
              fill="#AFAEBA"
            />
          </span>
        }
      >
        {getTooltipContent(type)}
      </MotifTooltip>
    </span>
  );
};

export default OrderItemsHeaderTooltip;
